import { apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

export const dataProductApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataProducts: builder.query({
      query: () => '/data_products',
      providesTags: (result = [], error, arg) => [
        { type: 'DataProduct', id: 'LIST' }
      ],
    }),
    getDataProductSync: builder.query({
      query: (key) => `/data_products/${key}/check_sync`,
    }),
    syncDataProduct: builder.mutation({
      query: (payload) => ({
        url: 'data_products/sync',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: [{ type: 'DataProduct', id: 'LIST' }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetDataProductsQuery,
  useLazyGetDataProductSyncQuery,
  useSyncDataProductMutation
} = dataProductApiSlice
